import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

export default function PaymentCancel() {
  const { t } = useLang();
  return (
    <div data-testid="payment-cancel-page" className="min-h-[70vh] flex items-center justify-center px-6 pt-24 pb-16">
      <div className="text-center max-w-md">
        <XCircle className="w-14 h-14 text-ivory/65 mx-auto mb-6" />
        <h1 className="font-serif text-4xl mb-3">{t("payment.cancel_title")}</h1>
        <p className="text-ivory/60 mb-8">{t("payment.cancel_sub")}</p>
        <Link to="/panier" data-testid="cancel-back-to-cart" className="bg-gold text-ink font-semibold px-7 py-3 rounded-full hover:bg-champagne transition-colors duration-300">
          {t("payment.back_to_cart")}
        </Link>
      </div>
    </div>
  );
}
